import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setPrevPage, setNextPage } from '../../../redux/slices/appStateSlice';

const ConfirmPartnerDetailsLogic = ({ fields, depens }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (depens?.children?.length === 1) {
      dispatch(setNextPage(fields.applyChildDetailsPage?.value?.href));
    } else if (depens?.children?.length > 1) {
      dispatch(setNextPage(fields.applyChildrenDetailsPage?.value?.href));
    } else {
      dispatch(setNextPage(fields.yourAddressPage?.value?.href));
    }
  }, [depens]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    depens: state.quoteData?.prospectDetails?.dependents,
  };
};
export default connect(mapStateToProps)(ConfirmPartnerDetailsLogic);
